import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgCrying: React.FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 300 401" {...props}>
    <g fill="#5ec0ff">
      <path d="M135.4 248.1s9.9 31.2.1 31.6c-.1 0-15.1 4-.1-31.6zM135.7 204.9s15.7 22.2 0 33.4c0 0-5.3 0-6.9-8.4 0 0 1-18 6.9-25z" />
    </g>
    <g fill="#b8b8b8">
      <path d="M276.6 246.7h.2c11.7-3 13.5-12.5 13.5-20.1 0-1.4-.9-2.5-2-2.5s-3-.1-3 1.3c0 .7-.5 13.3-9.9 15-1.1.2-.9 2.7-.8 4.1.2 1.2 1 2.2 2 2.2zM285 256.3h.2c14.1-5.6 15.3-16.9 14.3-25.7-.2-1.6-1.4-2.8-2.8-2.6s-2.3 2-2.2 3.6c.1.8 1 15.5-10.4 19.1-1.3.4-2.2 1.6-1.9 3.2.4 1.5 1.6 2.5 2.8 2.4z" />
    </g>
    <g fill="#b8b8b8">
      <path d="M21.9 110.3h-.2c-11.2 4.5-11.9 14.1-10.8 21.6.2 1.4 1.2 2.4 2.3 2.3 1.1-.2 3-.3 2.8-1.7-.1-.7-1.2-13.3 7.9-16.1 1.1-.3.6-2.7.3-4.1-.3-1.2-1.2-2.1-2.3-2z" />
      <path d="M12.4 101.9c-.1 0-.1 0-.2.1-13.3 7.3-13 18.7-10.9 27.3.4 1.6 1.8 2.6 3.1 2.2 1.3-.4 2.1-2.3 1.7-3.9-.2-.8-3-15.2 7.9-20.2 1.3-.6 2-1.9 1.5-3.5-.5-1.5-1.8-2.3-3.1-2z" />
    </g>
    <g fill="#5ec0ff">
      <path d="M221 201.3s11.2 30.8 2.8 32.2c0 .1-12.6 5.7-2.8-32.2zM223.3 275.1s10.1 32 .1 32.4c0 0-15.4 4.1-.1-32.4zM221.7 238.9s15.7 22.2 0 33.4c0 0-5.3 0-6.9-8.4 0 0 1-18 6.9-25zM224.3 311.5s15.7 27.7 0 41.7c0 0-5.3 0-6.9-10.5 0 0 1.1-22.4 6.9-31.2z" />
    </g>
    <path
      d="M45.7 128.3c0 43.6 22.2 66.2 60.5 84.3 15.5 7.4 49.1 12.2 67.6 12.2 40.1 0 58.7-11.7 79.6-41.2 12.5-17.7 19.8-39.1 19.8-62.1 0-32.9-8.8-62.5-32.6-82.8-20.5-17.5-51.5-28.2-81.2-28.2-32.1 0-61.1 12.4-82.1 32.5s-31.6 54.7-31.6 85.3z"
      fill="#ff7300"
    />
    <path
      d="M93.8 53.3S109.7-11 126.1 2c7.7 6.1 5.5 5.6 17 20.9S91.6 61.1 93.8 53.3z"
      fill="#d85700"
    />
    <path
      d="M106.2 212.7c-39.5-15.4-60.5-40.7-60.5-84.3 0-30.6 10.6-65.2 31.6-85.2s50.1-32.5 82.1-32.5c14.8 0 30 2.7 44 7.5 0 0-24.3 2-49 17-24.9 15.1-50.2 43.4-51.2 82.6 0 0-2.7 43.2 7.6 68.9 5 12.4 0 0 0 0l24.8 16.8s0 14.8 15.9 20.3c0-.1-25.4-3.3-45.3-11.1z"
      fill="#d85700"
    />
    <path
      d="M270.5 104.7s20.8-62.9 0-60.6c-9.8 1.1-7.6 1.8-25.5 8.6s23.1 59.7 25.5 52zM53.8 165s-26.9 6.1-13.7 21.3c0 0 5.9 4.4 13.2.4 0 0-4.5 5.8-2.5 10.5 0 0 9.1 10.3 20.4 1.2 0 0-3 7.4 3.4 14.8 0 0 9.9 9.6 17.2-5.6 0 0-1.9 8.2 3.3 10.5 0 0 10.7 8.1 29.9-2.3 0 0 11.6-4.6 10.6-12.3 0-.1-43.9-39-81.8-38.5z"
      fill="#ff7300"
    />
    <path
      d="M255.9 160.9s9.5 62.9-19.4 66.3c0 0-3.9.5-6.7-1-2.4-1.2-12-6.8-6.9-34.8 0 .1-18.6-26.1 33-30.5z"
      fill="#d85700"
    />
    <path
      d="M259.5 159.3s9.5 62.9-19.4 66.3c0 0-3.9.5-6.7-1-2.4-1.2-12-6.8-6.9-34.8 0 .1-18.6-26.1 33-30.5z"
      fill="#ff7300"
    />
    <g>
      <path
        d="M91.7 341.2c0-.3-.1-.5-.1-.8-.9-10.2 16.6-20 38.9-21.9 7.5-.6 14.6-.3 20.8.8 4.5-1.3 9.6-2.3 15-2.7 19.1-1.6 35.1 3.4 35.7 11.3.1 1.1-.1 2.1-.6 3.1 29.3-2.4 53.6 3.6 54.5 13.5.4 4.2-3.6 8.4-10.5 12.1 17.8 1.9 30.7 8.6 31.5 17.5 1 12.1-20.6 23.8-48.4 26.2-24.2 2.1-45-3.7-50.6-13.2-20.1 1.1-36.3-2.7-36.8-9.1-.1-1.6.7-3.2 2.4-4.7-8.9 2.1-18.9 3.7-29.6 4.6-36.8 3.1-67.4-3.1-68.3-13.9-.8-8.9 18.7-18 46.1-22.8z"
        fill="#5ec0ff"
      />
      <path
        d="M110.5 373.5c1.8-.2 3.6-.3 5.5-.5 1.1-.1 1.9-1.2 1.8-2.3-.1-1.1-1.1-2-2.2-1.9-47.8 5.1-56.7-7.8-56.8-7.9-.6-1-1.8-1.2-2.7-.7s-1.3 1.8-.7 2.8c.2.5 8.8 14.5 55.1 10.5zM170.8 383.8c-.4.2-.7.2-.7.2-7.5 1-13 .1-16.4-1.8-2.9-1.6-3.2-3-3.2-3-.1-.4.1-.9.3-1.3l.3-.4c.2-.3.7-.4 1-.2l.5.4.6.4.2.6s1.1 3.7 16.5 2.6c.8-.1 1.5.4 1.5 1.2.2 1-.6 1.3-.6 1.3z"
        fill="#e2f4ff"
      />
    </g>
  </svg>
);
/* eslint-enable max-len */

export default SvgCrying;
